<template>
  <div>
  <div :class="{ questionComponent: size == 1, 'pl24 homework': pageType == 2, knowledgeTest: pageType == 4 }" :id="info.sheetIndex">
    <!-- 题目 -->
    <div style="position: relative">
      <div :class="{ 'mb32 ml5 questionTitle': true, line: info.questionType == 5, titleHidden: pageType == 2 && isShowUnfold && !isUnfold }" ref="questionTitleRef" v-if="info.questionType != 999">
        <div class="title" v-html="info.questionTitle"></div>
        <el-image :src="info.questionImage" class="title-img" :preview-src-list="[info.questionImage]" fit="cover" v-if="info.questionImage" />
        <audio :src="info.questionAudio" controls class="title-audio" v-if="info.questionAudio" />
        <video :src="info.questionVideo" controls class="title-video" v-if="info.questionVideo" />
      </div>
      <div class="title-unfold-mask" v-if="pageType == 2 && isShowUnfold && !isUnfold"></div>
    </div>
    <slot name="title" />

    <!-- 我的作业-题目展开&收起 -->
    <div class="title-unfold mb32 pointer" v-if="pageType == 2 && isShowUnfold && size == 1 && info.questionType != 999" @click="unfold">
      <span>{{ isUnfold ? "收起" : "展开" }}</span>
      <img src="@/assets/questionBank/title-unfold.png" :class="{ ml8: true, unfoldDown: isUnfold }" />
    </div>

    <!-- 单选题 -->
    <template v-if="info.questionType == 0">
     
      <div
        :class="{
          'answer-option': true,
          'answer-userAnswer': !(isSubmit || info.isShowAnswer) && info.userAnswer == String.fromCharCode(65 + index),
          'answer-right': (isSubmit || info.isShowAnswer) && info.questionAnswer == String.fromCharCode(65 + index),
          'answer-wrong': (isSubmit || info.isShowAnswer) && info.userAnswer == String.fromCharCode(65 + index) && info.questionAnswer != String.fromCharCode(65 + index),
        }"
        v-for="(item, index) in info.questionOptionList"
        :key="index"
        @click="singleChoice(String.fromCharCode(65 + index))"
      >
        <div class="answer-i mr10 pointer">
          <i class="el-icon-check answer-check"></i>
          <i class="el-icon-close answer-error"></i>
        </div>
        <div class="answer-option-item pointer">{{ String.fromCharCode(65 + index) }}.</div>
        <div class="answer-option-item answer-option-item-content ml5 pointer" v-html="item"></div>
      </div>
    </template>

    <!-- 多选题 不定项选择题 -->
    <template v-if="[1, 6].includes(Number(info.questionType))">
      <div
        :class="{
          'answer-option': true,
          'answer-userAnswer': !(isSubmit || info.isShowAnswer) && info.userAnswer.includes(String.fromCharCode(65 + index)),
          'answer-right': (isSubmit || info.isShowAnswer) && info.questionAnswer.includes(String.fromCharCode(65 + index)),
          'answer-wrong': (isSubmit || info.isShowAnswer) && info.userAnswer.includes(String.fromCharCode(65 + index)) && !info.questionAnswer.includes(String.fromCharCode(65 + index)),
        }"
        v-for="(item, index) in info.questionOptionList"
        :key="index"
        @click="multipleChoice(String.fromCharCode(65 + index))"
      >
        <div class="answer-i mr10 pointer">
          <i class="el-icon-check answer-check"></i>
          <i class="el-icon-close answer-error"></i>
        </div>
        <div class="answer-option-item pointer">{{ String.fromCharCode(65 + index) }}.</div>
        <div class="answer-option-item ml5 pointer" v-html="item"></div>
      </div>
    </template>

    <!-- 判断题 -->
    <template v-if="info.questionType == 2">
      <div
        :class="{
          'answer-option': true,
          'answer-userAnswer': !(isSubmit || info.isShowAnswer) && info.userAnswer == String.fromCharCode(65 + index),
          'answer-right': (isSubmit || info.isShowAnswer) && info.questionAnswer == String.fromCharCode(65 + index),
          'answer-wrong': (isSubmit || info.isShowAnswer) && info.userAnswer == String.fromCharCode(65 + index) && info.questionAnswer != String.fromCharCode(65 + index),
        }"
        v-for="(item, index) in judgeOption"
        :key="index"
        @click="singleChoice(String.fromCharCode(65 + index))"
      >
        <div class="answer-i mr10 pointer">
          <i class="el-icon-check answer-check"></i>
          <i class="el-icon-close answer-error"></i>
        </div>
        <div class="answer-option-item pointer">{{ String.fromCharCode(65 + index) }}.</div>
        <div class="answer-option-item ml5 pointer" v-html="item"></div>
      </div>
    </template>

    <!-- 填空题 简答题 文件 -->
    <template v-if="[3, 4, 999].includes(Number(info.questionType))">
      <div class="textarea-box mb20">
        <el-input
          v-model="info.userAnswer"
          placeholder="请输入您的答案~"
          resize="none"
          type="textarea"
          :maxlength="maxLength"
          class="inputi"
          :disabled="isSubmit || isSingleBuy(false) || info.isShowAnswer"
          @input="touchWatch"
        />
        <div class="wordLength" v-if="!isSubmit && !info.isShowAnswer">
          <span>{{ info.userAnswer ? info.userAnswer.length : 0 }}</span>
          <span>/{{ maxLength }}</span>
        </div>
      </div>
      <div class="upload mb20" v-if="(!isSubmit && !info.isShowAnswer) || ((isSubmit || info.isShowAnswer) && info.imgList.length)">
        <div class="upload-img">
          <div :class="{ 'upload-item': true, mr16: index != imgCount - 1 }" v-for="(item, index) in info.imgList" :key="item.url + index">
            <el-image :src="item.url" fit="cover" class="upload-cover" :preview-src-list="getImgList()" :initial-index="index" v-if="item.url" />
            <img src="@/assets/questionBank/upload-del.png" class="upload-del pointer" @click="delImg(index)" v-if="!isSubmit && !info.isShowAnswer" />
          </div>
          <img src="@/assets/questionBank/uploadImg.png" class="upload-item pointer" v-if="info.imgList.length < imgCount && !isSubmit && !info.isShowAnswer" @click="clickUpload" />
          <input ref="fileInput" type="file" accept="image/png,image/jpg,image/jpeg" multiple @change="fileChange" class="fileInput" />
        </div>
        <div class="upload-tips" v-if="!isSubmit && !info.isShowAnswer">
          <span>{{ info.imgList.length }}</span>
          <span>/{{ imgCount }} 点击上传（最多可上传{{ imgCount }}张）</span>
        </div>
      </div>
    </template>

    <!-- 组合题 -->
    <template v-if="info.questionType == 5">
      <div class="mb40" v-for="(item, index) in info.subTopicList" :key="index">
        <Question
          :info="item"
          :size="2"
          :pageType="pageType"
          :isSubmit="isSubmit"
          :examStatus="examStatus"
          :isSingle="isSingle"
          :singleIsBuy="singleIsBuy"
          :isShowUserAnswer="isShowUserAnswer"
          :maxLength="maxLength"
          @answerFn="answerFn"
          @watchUserAnswer="touchWatch"
        />
      </div>
    </template>

    <!-- 专属题库刷题页 -->
    <template v-if="pageType == 3 && !info.isShowAnswer">
      <!-- 多选题、不定项-确认 -->
      <div :class="{ multipleSubmit: true, multipleSubmit2: size == 2 }" v-if="[1, 6].includes(Number(info.questionType))" @click="multipleSubmit">确认</div>

      <!-- 主观题-已掌握、未掌握 -->
      <div :class="{ grasp: true, grasp2: size == 2 }" v-if="[3, 4].includes(Number(info.questionType))">
        <div class="grasp-tips">（本题不支持系统判断正确错误，请自行判断）</div>
        <div class="grasp-buts">
          <div @click="master(1)">已掌握</div>
          <div @click="master(0)">不了解</div>
        </div>
      </div>
    </template>

    <!-- 录音 -->
    <div class="record" v-if="pageType == 2">
      <template v-if="!isSubmit">
        <div class="record-title pl10 mb16">上传录音</div>
        <div class="record-flex mb16">
          <el-button :class="{ 'record-but': true, 'record-start': !isRecord, 'record-ing': isRecord }" @click="record" :loading="uploadRecordLoading" :disabled="uploadRecordLoading">
            <img src="@/assets/questionBank/record-1.png" v-if="!isRecord" />
            <img src="@/assets/questionBank/record-2.png" v-else />
            <span>{{ isRecord ? "正在录音" : "点击录音" }}</span>
          </el-button>
          <div class="record-tips ml12">
            <span>{{ info.userAnswerRecordingList ? info.userAnswerRecordingList.length : 0 }}</span>
            <span>/9 点击上传录音（最多可上传9条）</span>
          </div>
        </div>
      </template>
      <RecordList ref="recordListRef" :isShowDel="!isSubmit" :list="info.userAnswerRecordingList" :info="info" :isRecord="isRecord" @del="delRecord" />
    </div>
  </div>

  <!-- 答案 解析 老师点评 知识点 -->
  <template v-if="(isSubmit || info.isShowAnswer) && (objective.includes(Number(info.questionType)) || (subjective.includes(Number(info.questionType)) && (examStatus == '4' || !isSingle)))">
    <template v-if="info.questionType != 5">
      <!-- 答案 -->
      <div :class="{ 'answer pr20 mt23': true, pl43: size == 1, pl30: size == 2 }" v-if="pageType != 2">
        <div
          :class="{ 'answer-item mr70': true, 'answer-right': info.isRight, 'answer-wrong': !info.isRight, 'answer-noAnswer': !info.isAnswer }"
          v-if="objective.includes(Number(info.questionType)) && isShowUserAnswer"
        >
          <div class="answer-item-status"></div>
        
          <span>您的答案： </span>
          <span class="answer-item-userAnswer" v-if="[0, 2].includes(Number(info.questionType))">{{ info.userAnswer ? info.userAnswer : "未做答" }}</span>
          <span class="answer-item-userAnswer" v-if="[1, 6].includes(Number(info.questionType))">{{ info.userAnswer.length != 0 ? info.userAnswer.toString() : "未做答" }}</span>
        </div>
        <div class="answer-item answer-right answer-reference">
          <div class="answer-item-status"></div>
          <span>参考答案：</span>
          <span :class="{ 'answer-item-userAnswer': true, 'subjective-answer-item-questionAnswer': subjective.includes(Number(info.questionType)) }" v-html="info.questionAnswer"></span>
        </div>
        <!-- 答疑 -->
        <div class="answerQuestion-setUp"></div>
        <div class="answerQuestion" @click="openAnswerQuestion">
          <img src="@/assets/questionBank/answerQuestion-icon.png" />
          <span>答疑</span>
        </div>
      </div>

      <!-- 试题解析 -->
      <div :class="{ analysis: true, mt20: pageType != 2, 'pl43 pr34': size == 1 && pageType != 2, 'pl24 pr24 mt8': size == 1 && pageType == 2 }">
        <div class="analysis-title mb12 pl10">试题解析</div>
        <div class="analysis-content pl10" v-html="info.questionAnswerAnalysis"></div>
        <el-image :src="info.questionAnswerAnalysisImage" class="title-img" :preview-src-list="[info.questionAnswerAnalysisImage]" v-if="info.questionAnswerAnalysisImage" />
        <audio :src="info.questionAnswerAnalysisAudio" class="title-audio" controls v-if="info.questionAnswerAnalysisAudio" />
        <video :src="info.questionAnswerAnalysisVideo" controls class="title-video" v-if="info.questionAnswerAnalysisVideo" />
        <div class="analysis-content pl10" v-if="!info.questionAnswerAnalysis && !info.questionAnswerAnalysisImage && !info.questionAnswerAnalysisAudio && !info.questionAnswerAnalysisVideo">无</div>
      </div>

      <!-- 老师点评 -->
      <div :class="{ 'analysis mt20': true, 'pl43 pr34': size == 1 && pageType != 2, pl24: size == 1 && pageType == 2 }" v-if="info.comment && (info.comment.content || info.comment.img)">
        <div class="analysis-title mb12 pl10">
          <span v-if="pageType == 2">老师评语</span>
          <span v-else>老师点评</span>
        </div>

        <div class="analysis-content pl10" v-html="info.comment.content" v-if="info.comment.content"></div>

        <div class="mt14">
          <RecordList ref="teacherRecord" :isShowDel="false" :list="info.comment.recordList" :info="info" :isRecord="isRecord" />
        </div>

        <div :class="{ 'teacher-img': true, mt16: !info.comment.recordList || info.comment.recordList.length == 0 }" v-if="info.comment.img && info.comment.img.length && pageType == 2">
          <el-image :src="item" :preview-src-list="info.comment.img" fit="cover" class="teacher-img-cover" v-for="item in info.comment.img" :key="item" />
        </div>
        <el-image :src="info.comment.img" class="title-img ml10" :preview-src-list="[info.comment.img]" fit="cover" v-else-if="info.comment.img && info.comment.img.length" />
      </div>
    </template>
 
  </template>

  <!-- 知识点测试做题 -->
  <div class="knowledgeTest" v-if="pageType == 4 && size == 1">
    <!-- 多选、不定项、主观题-确认 -->
    <div class="multipleSubmit" v-if="[1, 3, 4, 5, 6].includes(Number(info.questionType)) && !info.isAnswer" @click="multipleSubmit">提交答案</div>

    <!-- 主观题-已掌握、未掌握 -->
    <div class="grasp" v-if="[3, 4, 5].includes(Number(info.questionType)) && info.isAnswer && info.isMaster === ''">
      <div class="grasp-tips">（本题不支持系统判断正确错误，请自行判断）</div>
      <div class="grasp-buts">
        <div @click="master(1)">已掌握</div>
        <div @click="master(0)">不了解</div>
      </div>
    </div>
  </div>

  <!-- 我的提问 -->
  <div :class="{ 'analysis mt20': true, 'pl43 pr34': size == 1 && pageType != 2, 'pl24 pr24': size == 1 && pageType == 2 }" v-if="info.workQuestionList && info.workQuestionList.length">
    <div class="analysis-title mb12 pl10">我的提问</div>
    
    <div class="quiz mb10" v-for="(item, index) in info.workQuestionList" :key="index">
      <div class="quiz-info">
        <img src="@/assets/questionBank/quiz-tw.png" class="quiz-icon" v-if="item.type == 1" />
        <img src="@/assets/questionBank/quiz-hd.png" class="quiz-icon" v-else />
        <span class="quiz-name mr8">{{ item.userName }}</span>
        <span class="quiz-time">{{ item.createTime }}</span>
      </div>
      <div class="quiz-content mt8">{{ item.content }}</div>
      <div class="mt14" v-if="item.recordingList && item.recordingList.length">
        <RecordList ref="myQuizRecordListRef" :list="item.recordingList" :isShowDel="false" />
      </div>
      <div class="quiz-img mt16" v-if="item.imgList && item.imgList.length">
        <el-image :src="ite" fit="cover" :preview-src-list="item.imgList" :initial-index="idx" class="quiz-img-item mb10" v-for="(ite, idx) in item.imgList" :key="idx" />
      </div>
    </div>
    </div>

 

  <!-- 答疑 -->
  <answerQuestion ref="answerQuestionRef" />
</div>
</template>

<script>
import Recorder from "recorder-core";
import "recorder-core/src/engine/mp3";
import "recorder-core/src/engine/mp3-engine";

import Question from "./question.vue";
import RecordList from "./recordList.vue";
import answerQuestion from "./answerQuestion.vue"; 
import { uploadFile } from "@/utils/uploadTSP"; 

export default {
  name: 'Question',
  components: {
    Question,
    RecordList,
    answerQuestion, 
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 页面类型 1正常做题页 2我的作业做题页 3专属题库刷题页 4知识点测试做题
    pageType: {
      type: Number,
      default: 1
    },
    // 1第一层 2嵌套第二层
    size: {
      type: Number,
      default: 1
    },
    // 是否提交
    isSubmit: {
      type: Boolean,
      default: false
    },
    // 阅卷状态
    examStatus: {
      type: [String, Number],
      default: "0"
    },
    // 第几题
    current: {
      type: Number,
      default: 0
    },
    // 是否为单题显示
    isSingle: {
      type: Boolean,
      default: false
    },
    // 单题是否购买
    singleIsBuy: {
      type: Number,
      default: 0
    },
    // 图片上传数量
    imgCount: {
      type: Number,
      default: 4
    },
    // 是否从学习中心打开(0否1是 知识点功能使用)
    isStudyCenter: {
      type: Number,
      default: 0
    },
    // 是否显示你的答案
    isShowUserAnswer: {
      type: Boolean,
      default: true
    },
    // 主观题答案最大长度
    maxLength: {
      type: Number,
      default: 2000
    }
  },
  data() {
    return {
      // 客观题类型
      objective: [0, 1, 2, 6],
      // 主观题类型
      subjective: [3, 4, 5],
      // 判断题选项
      judgeOption: ["正确", "错误"],
      // 录音相关
      rec: null,
      isRecord: false,
      uploadRecordLoading: false,
      // 图片相关
      imgId: 1,
      // 视频相关
      videoShow: false,
      videoInfo: {},
      isCc: false,
      // 题目展开相关
      isShowUnfold: false,
      isUnfold: false, 
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.disposeTitle(this.info);
    });
  },
  beforeDestroy() {
    if (this.isRecord) {
      this.rec.stop();
    }
  },
  watch: {
    current: {
      handler() {
        if (this.info.topicId || this.info.questionId) {
          const id = this.info.topicId ? this.info.topicId : this.info.questionId;
          this.getKnowledgeList(id);
        }
      },
      immediate: true
    },
    info: {
      handler(value) {
        this.isShowUnfold = false;
        this.isUnfold = false;
        this.stopRecordPlay();
        // 设置标题
        this.disposeTitle(value);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 判断是否为单题显示以及是否购买
    isSingleBuy(isTips = true) {
      if (this.isSingle && !Boolean(Number(this.singleIsBuy))) {
        if (isTips) {
          this.$notify.closeAll();
          this.$notify({
            title: "提示",
            message: "该试题未购买",
            type: "warning",
            duration: 1000
          });
        }
        return true;
      } else {
        return false;
      }
    },
    
    // 单选题选择 判断题
    singleChoice(code) {
      if (this.isSingleBuy()) return;
      if (this.isSubmit || this.info.isShowAnswer) return;
      this.info.userAnswer = code;
      this.info.pageSize = this.size;
      this.$emit("answerFn", this.info);
      this.$emit("watchUserAnswer");
    },
    
    // 多选题 不定项选择题
    multipleChoice(code) {
      if (this.isSingleBuy()) return;
      if (this.isSubmit || this.info.isShowAnswer) return;
      const index = this.info.userAnswer.findIndex((i) => i == code);
      if (index == -1) {
        this.info.userAnswer.push(code);
      } else {
        this.info.userAnswer.splice(index, 1);
      }
      this.info.userAnswer = this.info.userAnswer.sort();
      this.$emit("watchUserAnswer");
    },
    
    // 触发监听
    answerFn(item) {
      if (this.pageType == 3) {
        this.$emit("answerFn", item);
      }
    },
    
    touchWatch() {
      this.$emit("watchUserAnswer");
    },
    
    // 多选题、不定项题-确认
    multipleSubmit() {
      this.$emit("answerFn", this.info);
    },
    
    // 专属题库刷题页-是否掌握
    master(type) {
      this.info.isMaster = type;
      this.$emit("answerFn", this.info);
    },
    
    // 图片上传相关
    clickUpload() {
      if (this.isSingleBuy()) return;
      this.$refs.fileInput.value = "";
      this.$refs.fileInput.click();
    },
    
    async fileChange(e) {
      const files = Array.from(e.target.files).filter((i) => i.type.includes("image"));
      // 确保imgList数组存在
      if (!this.info.imgList) {
        this.$set(this.info, 'imgList', []);
      }
      const arr = files.slice(0, this.imgCount - this.info.imgList.length);
      let num = 0;
      for (const item of arr) {
        const url = await uploadFile(item);
        const newImg = {
          id: this.imgId++,
          url: url
        };
        this.info.imgList.push(newImg);
        num++;
        if (num == arr.length) {
          this.$emit("watchUserAnswer");
        }
      }
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    
    delImg(index) {
      this.info.imgList.splice(index, 1);
      this.$emit("watchUserAnswer");
    },
    
    getImgList() {
      return this.info.imgList.map((i) => i.url);
    },
    
    // 知识点相关
    getKnowledgeList(id) {
      this.$nextTick(() => {
        if (this.$refs.knowledgeRef) {
          this.$refs.knowledgeRef.getKnowledgeList(id);
        }
      });
    },
    
    // 播放视频
    playVideo(ite) {
      this.videoShow = true;
      if (ite.playbackClientCode == 1) {
        // cc直播回放视频
        this.isCc = true;
      } else {
        // 录播视频
        this.isCc = false;
      }
      setTimeout(() => {
        if (this.isCc) {
          if (this.$refs.ccPlayerRef) {
            this.$refs.ccPlayerRef.init(ite);
          }
        } else {
          this.videoInfo = ite;
        }
      }, 0);
    },
    
    // 视频关闭
    videoClose() {
      this.videoShow = false;
      this.videoInfo = {};
      this.isCc = false;
    },
    
    // 录音相关
    record() {
      if (this.info.userAnswerRecordingList && this.info.userAnswerRecordingList.length >= 9) return;
      if ((this.$refs.recordListRef && this.$refs.recordListRef.isPlay()) || 
          (this.$refs.myQuizRecordListRef && this.$refs.myQuizRecordListRef.isPlay()) || 
          (this.$refs.teacherRecord && this.$refs.teacherRecord.isPlay())) {
        this.$notify.closeAll();
        this.$notify({
          title: "提示",
          message: "请先暂停当前播放的录音",
          type: "warning",
          duration: 2000,
          zIndex: 2100
        });
        return;
      }
      if (!this.isRecord) {
        this.rec = Recorder({
          type: "mp3", //录音格式，可以换成wav等其他格式
          sampleRate: 16000, //录音的采样率，越大细节越丰富越细腻
          bitRate: 16, //录音的比特率，越大音质越好
        });
        this.rec.open(
          () => {
            this.rec.start();
            this.isRecord = true;
          },
          (err) => {
            this.$notify.closeAll();
            this.$notify({
              title: "提示",
              message: err,
              type: "warning",
              duration: 1500,
              zIndex: 2100
            });
          }
        );
      } else {
        this.isRecord = false;
        this.rec.stop(
          (blob) => {
            const file = new window.File([blob], new Date().getTime() + "" + parseInt(Math.random() * 10000 + "") + ".mp3");
            const url = (window.URL || webkitURL).createObjectURL(blob);
            this.getRecordFile({
              file,
              url
            });
          },
          (err) => {
            console.error("结束录音出错：", err);
          }
        );
      }
    },
    
    async getRecordFile(data) {
      this.uploadRecordLoading = true;
      const url = await uploadFile(data.file, {
        path: "/record",
        bucketName: "1678655958080851969-other"
      });
      this.uploadRecordLoading = false;
      if (!this.info.userAnswerRecordingList) {
        this.info.userAnswerRecordingList = [];
      }
      this.info.userAnswerRecordingList.push(url);
      this.$emit("watchUserAnswer");
    },
    
    delRecord(index) {
      this.info.userAnswerRecordingList.splice(index, 1);
      this.$emit("watchUserAnswer");
    },
    
    getIsRecord() {
      return this.isRecord;
    },
    
    stopRecordPlay() {
      if (this.$refs.recordListRef) {
        this.$refs.recordListRef.stopPlay();
      }
      if (this.$refs.myQuizRecordListRef && this.$refs.myQuizRecordListRef[0]) {
        this.$refs.myQuizRecordListRef[0].stopPlay();
      }
      if (this.$refs.teacherRecord && this.$refs.teacherRecord[0]) {
        this.$refs.teacherRecord[0].stopPlay();
      }
    },
    
    // 题目展开
    unfold() {
      this.isUnfold = !this.isUnfold;
    },
    
    // 设置标题
    disposeTitle(value) {
      if (value.questionType != 999) {
        if (!value.isChangeTitle && this.pageType != 2) {
          value.isChangeTitle = true;
          value.questionTitle = this.setTitle(value, 1);
          if (value.questionType == 5 && value.subTopicList) {
            value.subTopicList
              .filter((item) => !item.isChangeTitle)
              .forEach((item, index) => {
                item.isChangeTitle = true;
                item.questionTitle = this.setTitle(item, 2, index);
              });
          }
        }
        this.$nextTick(() => {
          if (this.$refs.questionTitleRef && this.$refs.questionTitleRef.offsetHeight > 170) {
            this.isShowUnfold = true;
          }
        });
      }
    },
    
    setTitle(value, size = 1, index) {
      if (!value.questionTitle) return;
      let title = value.questionTitle;
      const startIndex = title.indexOf("<p>");
      let order;
      if (size == 1) {
        order = `${this.current ? this.current : value.topicIndex}.`;
      } else if (size == 2) {
        order = `<span style='color: #3366ff' class='mr5'>${index + 1}、${questionEnum[Number(value.questionType)]}</span>`;
      }
      if (startIndex == 0) {
        title = title.slice(0, 3) + order + title.slice(3);
      } else {
        title = order + title;
      }
      return title;
    },
    
    // 答疑
    openAnswerQuestion() {
      if (this.$refs.answerQuestionRef) {
        this.$refs.answerQuestionRef.open(this.info);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  
.questionComponent {
  padding-top: 26px;
  padding-left: 43px;
  padding-right: 22px;
  position: relative;
}
.line {
  border-bottom: 1px dashed #eee;
  padding-bottom: 20px;
  margin-bottom: 20px !important;
}
.questionTitle {
  position: relative;
}
.titleHidden {
  height: 170px;
  overflow-y: scroll;
}
.title-unfold-mask {
  width: 100%;
  height: 20px;
  background-color: #fff;
  filter: blur(3px);
  position: absolute;
  bottom: -15px;
  left: 0;
}
.title {
  font-size: 16px;
  color: #333;
  line-height: 30px;
  word-break: break-all;
  .questionType {
    color: #3366ff;
    margin-right: 5px;
  }
}
.title-img {
  width: 200px;
  height: 200px;
  margin: 20px 0;
  display: block;
  border-radius: 10px;
}
.title-audio {
  margin: 20px 0;
}
.title-video {
  width: 100%;
  height: 300px;
  margin: 20px 0;
}
.title-unfold {
  width: 130px;
  height: 36px;
  border-radius: 19px;
  background-color: #f7f7fa;
  margin: 0 auto;
  font-size: 14px;
  color: #777;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 8px;
    transition: all 0.3s;
  }
  .unfoldDown {
    transform: rotate(180deg);
  }
}
.answer-option {
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: flex-start;
  margin-bottom: 22px;
}
.answer-i {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #999;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  color: #fff;
  position: relative;
  .answer-check {
    display: none;
  }
  .answer-error {
    display: none;
  }
}
.answer-userAnswer {
  .answer-i {
    border-color: #3366ff;
    background-color: #3366ff;
    &::after {
      content: "";
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
.answer-right {
  color: #34b851;
  .answer-i {
    border-color: #34b851;
    background-color: #34b851;
    .answer-check {
      display: inline-block;
    }
  }
}
.answer-wrong {
  color: #ff3030;
  .answer-i {
    border-color: #ff3030;
    background-color: #ff3030;
    .answer-error {
      display: inline-block;
    }
  }
}
.answer-option-item {
  display: inline-block;
}
.answer-option-item-content {
  flex: 1;
  flex-wrap: wrap;
}
.sizeTwo-option-item {
  color: #3366ff !important;
}
.inputi {
  height: 180px;
  :deep(textarea) {
    height: 100%;
    padding: 14px 16px 0;
    font-size: 15px;
    color: #333 !important;
    box-shadow: none !important;
    background-color: #f7f7fa !important;
    word-break: break-all;
  }
  :deep(.el-input__count) {
    bottom: 14px;
    right: 16px;
  }
}
.textarea-box {
  position: relative;
  // background-color: #f7f7fa;
  border-radius: 8px;
  overflow: hidden;
  .wordLength {
    font-size: 14px;
    color: #777;
    padding: 5px 16px 14px;
    text-align: right;
    span:first-child {
      color: #3366ff;
    }
  }
}
.upload {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  .upload-img {
    display: flex;
  }
  .upload-item {
    width: 110px;
    height: 110px;
    position: relative;
    .upload-cover {
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
    .upload-del {
      width: 24px;
      height: 24px;
      position: absolute;
      top: -12px;
      right: -12px;
    }
  }
  .upload-tips {
    font-size: 14px;
    color: #aaa;
    margin-left: 14px;
    span:first-child {
      color: #3366ff;
    }
  }
  .fileInput {
    opacity: 0;
    display: none;
  }
}
.answer {
  width: 100%;
  padding: 24px 0;
  background-color: #f9fbff;
  display: flex;
  align-items: center;
  border-top: 1px dashed #eee;
  position: relative;
  .answer-item {
    display: flex;
    align-items: flex-start;
    font-size: 16px;
    color: #333;
    .answer-item-status {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin-right: 5px;
      transform: translateY(6px);
    }
    .answer-item-userAnswer {
      font-weight: bold;
    }
    &:last-child {
      .answer-item-userAnswer {
        flex: 1;
      }
    }
    .subjective-answer-item-questionAnswer {
      flex: 1;
      color: #333 !important;
      font-weight: normal !important;
    }
  }
  .answer-right {
    .answer-item-status {
      background-color: #34b851;
    }
    .answer-item-userAnswer {
      color: #34b851;
    }
  }
  .answer-wrong {
    .answer-item-status {
      background-color: #ff3030;
    }
    .answer-item-userAnswer {
      color: #ff3030;
    }
  }
  .answer-noAnswer {
    .answer-item-status {
      background-color: #aaa;
    }
    .answer-item-userAnswer {
      color: #aaa;
    }
  }
  .answer-reference {
    flex: 1;
    width: 0;
    word-break: break-all;
    flex-wrap: wrap;
  }
  .answerQuestion-setUp {
    width: 90px;
    height: 36px;
  }
  .answerQuestion {
    width: 90px;
    height: 36px;
    background-color: #e6efff;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #1061ff;
    line-height: 1;
    cursor: pointer;
    position: absolute;
    right: 20px;
    top: 24px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 6px;
      display: block;
      transform: translateY(1px);
    }
  }
}
.analysis {
  .analysis-title {
    position: relative;
    color: #333;
    font-size: 14px;
    font-weight: bold;
    &::after {
      content: "";
      width: 4px;
      height: 14px;
      background-color: #3366ff;
      border-radius: 2px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      margin-top: 1px;
    }
  }
  .analysis-content {
    font-size: 14px;
    color: #777;
  }
}

.player-main {
  width: 100%;
  height: 495px;
  position: relative;
  background: #2e2e2e;
}
.homework {
  .upload {
    display: block;
  }
  .upload-item {
    width: 76px;
    height: 76px;
    .upload-del {
      width: 16px;
      height: 16px;
      top: -8px;
      right: -8px;
    }
  }
  .upload-tips {
    margin-left: 0;
    margin-top: 12px;
  }
}
.record {
  .record-title {
    font-size: 16px;
    color: #333;
    position: relative;
    &::before {
      content: "";
      width: 4px;
      height: 12px;
      background-color: #3366ff;
      border-radius: 2px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .record-flex {
    display: flex;
    align-items: flex-end;
  }
  .record-but {
    width: 144px;
    height: 40px;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    img {
      width: 13px;
      height: 18px;
      margin-right: 6px;
    }
  }
  .record-start {
    background: linear-gradient(180deg, #97b2ff 0%, #3067ff 100%);
  }
  .record-ing {
    background: linear-gradient(180deg, #ffa997 0%, #ff3030 100%);
  }
  .record-tips {
    font-size: 14px;
    color: #aaa;
    span:first-child {
      color: #3366ff;
    }
  }
}
.quiz {
  font-size: 14px;
  .quiz-info {
    display: flex;
    align-items: center;
    .quiz-icon {
      width: 19px;
      height: 19px;
      margin-right: 10px;
    }
    .quiz-name {
      color: #333;
    }
    .quiz-time {
      color: #999;
    }
  }
  .quiz-content {
    color: #777;
    line-height: 26px;
    word-break: break-all;
  }
  .quiz-img {
    display: flex;
    flex-wrap: wrap;
    .quiz-img-item {
      width: 76px;
      height: 76px;
      border-radius: 8px;
      margin-right: 15px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.multipleSubmit {
  width: 200px;
  height: 50px;
  border-radius: 6px;
  background: linear-gradient(180deg, #97b2ff 0%, #3067ff 100%);
  font-size: 16px;
  color: #fff;
  text-align: center;
  line-height: 50px;
  margin: 58px auto;
  cursor: pointer;
}
.multipleSubmit2 {
  margin: 0 auto;
}
.grasp {
  margin-top: 76px;
  .grasp-tips {
    text-align: center;
    font-size: 14px;
    color: #aaa;
    margin-bottom: 20px;
  }
  .grasp-buts {
    display: flex;
    justify-content: center;
    div {
      width: 243px;
      height: 49px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      color: #333;
      border: 1px solid #ebebeb;
      border-radius: 8px;
      margin: 0 20px;
      cursor: pointer;
    }
  }
}
.grasp2 {
  margin-top: 0;
}
.teacher-img {
  margin-left: 10px;
  display: flex;
  flex-wrap: wrap;
  .teacher-img-cover {
    width: 76px;
    height: 76px;
    border-radius: 8px;
    margin-right: 16px;
    margin-bottom: 10px;
  }
}
.knowledgeTest {
  .multipleSubmit {
    margin: 42px auto;
  }
  .grasp {
    margin-top: 44px;
  }
}
</style>